export class PromiseWrapper {
    static delay(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    get ended() {
        return this.rejected || this.resolved;
    }
    constructor() {
        this.rejected = false;
        this.resolved = false;
        this.promise = new Promise((resolve, reject) => {
            this.resolve = (t) => {
                if (!this.resolved && !this.rejected) {
                    this.resolved = true;
                    resolve(t);
                }
            };
            this.reject = (err) => {
                if (!this.resolved && !this.rejected) {
                    this.rejected = true;
                    reject(err);
                }
            };
        });
    }
    setTimeout(ms, error) {
        return setTimeout(() => {
            this.reject(error ?? "PromiseWrapper timed out");
        }, ms);
    }
}
